import { Component, Input } from '@angular/core';
import { Transaction } from '../../models/transactionmodel';
import { Recon } from '../../models/reconmodel';
import { Search } from '../../models/searchmodel';
import { transactionService } from '../../services/transaction.service';
import { SharedService } from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { PaymentResponse } from '../../models/responsemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as alaSQLSpace from 'alasql';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';

@Component({
  templateUrl: './report.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [transactionService]
})

export class ReportComponent {
  @Input() responseObj: Session;
  public transactions: Transaction[];
  public recon: Recon;
  public search: Search;
  public enablestorefield: boolean;
  errorMessage: string;
  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: [],
    showTitle: true,
    title: 'asfasf',
    useBom: false,
    removeNewLines: true,
    keys: ['smartcard', 'basketid', 'merchantreference']
  };
  public data;
  public objectKeys = Object.keys;
  public transno = 0;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'yyyy-mm-dd',
  };

  private selDate: IMyDate = { year: 0, month: 0, day: 0 };


  constructor(private _transactionService: transactionService, public router: Router, public sharedservice: SharedService) {
    // // set today to selDate attribute
    // let d: Date = new Date();
    // this.selDate = {year: d.getFullYear(),
    //                 month: d.getMonth() + 1,
    //                 day: d.getDate()};
  }

  ngOnInit() {
    // call the method on initial load of page to bind dropdown
    this.getLast10Transactions();
    this.recon = new Recon();
    this.search = new Search();
    if (!this.sharedservice.isAdmin() && !this.sharedservice.isViewer()) {
      this.enablestorefield = true;
      this.sharedservice.checkCredentials();
      if (this.sharedservice.isMerchant()) {
        this.search.searchstoreid = this.sharedservice.session.account_username;
      }
      else {
        this.search.searchstoreid = this.sharedservice.session.account_userstore;
      }
    }
    else {
      this.enablestorefield = false;
    }

    //console.log(JSON.stringify(this.transactions));
  }

  onStartDateChanged(event: IMyDateModel) {

    this.search.searchfromdate = event.formatted;
    // date selected
    //console.log('Formatted date: ', event.formatted);
  }

  onEndDateChanged(event: IMyDateModel) {
    this.search.searchtodate = event.formatted;
    // date selected
    // console.log('Formatted date: ', event.formatted);
  }


  postPayment(isValid: boolean) {
    if (isValid) {
      // this._PaymentService.makePayment(this.payment).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
    }
  }

  //Get the list of languages
  getLast10Transactions() {
    this._transactionService.getLast10Transactions().subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

  reconcileAllTransaction() {
    this._transactionService.reconcileAllTransaction(this.transactions);
  }

  reconcileTransaction() {
    this._transactionService.reconcileTransaction(this.recon).subscribe(res => res, error => this.errorMessage = <any>error);
    //this.getTransactions();
  }

  searchTransaction(isValid: boolean) {
    if (isValid)
      this._transactionService.searchTransaction(this.search).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

  retrieveAccount(merchantref, storeid) {
    this.recon.storeid = storeid;
    this.recon.merchantreference = merchantref;
  }

  exportXLS() {
    var data = this.transactions;
    var opts = [{ sheetid: 'Data', header: true }];
    alasql('SELECT INTO XLSX("report.xlsx",?) FROM ?', [opts, [data]]);
  }

  exportCSV() {
    var data = this.transactions;
    var opts = [{ header: true }];
    alasql('SELECT INTO CSV("report.csv",{header: true}) FROM ?', [opts, data]);
  }

  replacer(i, val) {
    if (val === null) {
      return ""; // Change null to empty
    } else {
      return val; // return unchanged
    }
  }


  handleResponse(result) {
    //console.log(JSON.stringify(result));
    this.transactions = JSON.parse(JSON.stringify(result, this.replacer));
    this.data = this.transactions;
    this.transno = result != null ? this.objectKeys(this.transactions).length : 0;
  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/transaction/report.component.ts